module.exports = __webpack_public_path__ + "static/media/DO.3e0cc5b5.png";